module.exports = __webpack_public_path__ + "static/img/item-2.001928a3.png";